/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Changes_DiscardedInputs */



/**
* | output |
* | --- |
* | "Changes discarded" |
*
* @param {Knp_Terms_Changes_DiscardedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_changes_discarded = /** @type {((inputs?: Knp_Terms_Changes_DiscardedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Changes_DiscardedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifications annulées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderungen verworfen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifiche scartate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменения отменены")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambios descartados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已放弃的更改")
	if (locale === "ja") return /** @type {LocalizedString} */ ("変更は破棄されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परिवर्तन खारिज कर दिए गए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alterações descartadas")
	return /** @type {LocalizedString} */ ("Changes discarded")
});